import React from "react";
import { FaArrowLeftLong, FaArrowRightLong } from "react-icons/fa6";

const Pagination = ({ currentPage, totalItems,  onPageChange }) => {
    const totalPages = Math.ceil(totalItems / 10);


    const pageNumbers = Array.from({ length: totalPages }, (_, index) => index);

    return (
        <div className="flex justify-between bg-white w-full p-4 px-10 mt-5">
            <div
                className={`flex items-center gap-2 cursor-pointer ${currentPage === 0 ? 'opacity-50' : ''}`}
                onClick={(e) => {
                    if (currentPage > 0) onPageChange(currentPage - 1, e); 
                }}
            >
                <FaArrowLeftLong /> Previous
            </div>
            <nav aria-label="Page navigation example">
                <ul className="flex items-center -space-x-px h-8 text-sm">
                    {pageNumbers.map((page) => (
                        <li key={page}>
                            <button
                                type="button"
                                onClick={(e) => onPageChange(page, e)}
                                className={`flex items-center justify-center px-3 h-8 leading-tight ${page === currentPage
                                    ? "text-white border border-gray-50 bg-gray-800"
                                    : "text-gray-500 bg-white border border-gray-300"
                                    } hover:bg-gray-100 hover:text-gray-700 dark:border-gray-700 dark:bg-gray-700 dark:text-white`}
                            >
                                {page + 1}
                            </button>
                        </li>
                    ))}
                </ul>
            </nav>
            <div
                className={`flex items-center gap-2 ${currentPage === totalPages - 1 ? 'opacity-50' : 'cursor-pointer'}`}
                onClick={(e) => {
                    if (currentPage < totalPages - 1) onPageChange(currentPage + 1, e); 
                }}
            >
                Next <FaArrowRightLong />
            </div>
        </div>
    );
};

export default Pagination;
